import { Text } from "@core/text";
import { GraduationCap } from "lucide-react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

interface MadlenAkademiModalProps {
  isOpen: boolean;
}

export function MadlenAkademiModal({ isOpen }: MadlenAkademiModalProps) {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[10000] bg-black/60 backdrop-blur-sm">
      <motion.div
        className="relative w-full max-w-lg mx-4"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.3 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-tr from-[#fae2c5] to-white text-gray-800 p-8 shadow-xl">
          <div className="relative z-10 flex flex-col items-center text-center space-y-4">
            <motion.div
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{
                type: "spring",
                stiffness: 260,
                damping: 20,
                delay: 0.1,
              }}
              className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mb-2 border border-primary-200 shadow-sm"
            >
              <GraduationCap size={36} className="text-primary-500" />
            </motion.div>

            <Text variant="h2" className="text-gray-800 font-bold text-2xl">
              {t("akademiModal.title")}
            </Text>

            <Text variant="p" className="text-gray-700 text-base max-w-md">
              {t("akademiModal.description")}
            </Text>
          </div>

          <div className="relative z-10 mt-8 flex flex-col items-center justify-center">
            <svg
              className="animate-spin h-12 w-12 text-primary-500 mb-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <Text variant="p" className="text-gray-700 text-lg font-medium">
              {t("common.loading")}
            </Text>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
